import { render, staticRenderFns } from "./JobDashboard.vue?vue&type=template&id=279988b2&scoped=true&"
import script from "./JobDashboard.vue?vue&type=script&lang=ts&"
export * from "./JobDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./JobDashboard.vue?vue&type=style&index=0&id=279988b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279988b2",
  null
  
)

export default component.exports